module.exports = __webpack_public_path__ + "media/images/icons/hlukovaMapaW-c333e1a247701c79a243226e80c3dd3c.svg";